import styled from 'styled-components'
import { Box } from 'src/components'

export const ContentPaginationSection = styled(Box)`
    height: 40px;
    display: flex;
    width: 50%;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const ButtonPagination = styled.button`
    height: 100%;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const Pagination = styled.button<{ isActive: boolean }>`
    height: 100%;
    width: auto;
    display: flex;
    align-items: center;
    font-weight: ${({ isActive }) => (isActive ? 'bold' : 'normal')};
    color: ${({ isActive, theme }) =>
        isActive ? theme.colors.primary : 'white'};
    justify-content: center;
    background: transparent;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const Image = styled.img`
    height: 40px;
    width: 40px;
    object-fit: contain;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
